/* Atlas Rug Cleaning — mobile-only correction-file adjustments.
   IMPORTANT: <=749px only. Desktop Canva rendering is preserved.
   - Moves the FREE artwork into the mobile hero via a visual clone.
   - Keeps the original Canva node in place (hidden only on mobile).
   - Restores every touched inline style when leaving mobile.
   - Slightly reduces selected colorful service-label sizes on mobile. */
(() => {
  const MOBILE_MAX = 749;
  const FREE_ASSET_TOKEN = '220e44ac3e403742f35f83b333a2';
  const FREE_CLONE_ID = 'atlas-free-mobile-fix';
  const FREE_WIDTH = 84;
  const FREE_LEFT = 1;
  const FREE_TOP = 38;
  const COLOR_LABELS = [
    'BEVERAGE SPILL', 'COFFEE STAINS', 'COLOR BLEEDING', 'FLOOD DAMAGE', 'FOOD STAINS'
  ];

  let observer = null;
  let applying = false;
  let resizeTimer = null;
  const originals = new Map();

  function remember(el) {
    if (!el || originals.has(el)) return;
    originals.set(el, el.getAttribute('style'));
  }

  function restoreTouched() {
    originals.forEach((style, el) => {
      if (!el?.isConnected) return;
      if (style == null) el.removeAttribute('style');
      else el.setAttribute('style', style);
    });
    originals.clear();
  }

  function leafByText(root, matcher) {
    return [...root.querySelectorAll('*')].filter(
      (el) => el.children.length === 0 && el.textContent && matcher(el.textContent.trim())
    );
  }

  function findFreeImage(root) {
    return [...root.querySelectorAll('img')].find((el) =>
      (el.currentSrc || el.src || '').includes(FREE_ASSET_TOKEN)
    ) || null;
  }

  function findCanvaOuterGroup(img, root) {
    let el = img;
    while (el && el !== root) {
      if (el.classList?.contains('DF_utQ') && el.classList?.contains('_0xkaeQ')) return el;
      el = el.parentElement;
    }
    return img;
  }

  function cleanupDesktop() {
    document.getElementById(FREE_CLONE_ID)?.remove();
    restoreTouched();
  }

  function positionFreeTag(root) {
    const hero = root.querySelector('section');
    const img = findFreeImage(root);
    if (!hero || !img) return;

    const originalGroup = findCanvaOuterGroup(img, root);
    remember(originalGroup);
    remember(hero);
    originalGroup.style.setProperty('visibility', 'hidden', 'important');
    hero.style.setProperty('position', 'relative', 'important');

    let clone = document.getElementById(FREE_CLONE_ID);
    if (!clone) {
      clone = img.cloneNode(true);
      clone.id = FREE_CLONE_ID;
      clone.removeAttribute('class');
      hero.appendChild(clone);
    }

    clone.style.cssText = [
      'position:absolute !important',
      `width:${FREE_WIDTH}px !important`,
      'height:auto !important',
      `left:${FREE_LEFT}px !important`,
      `top:${FREE_TOP}px !important`,
      'right:auto !important',
      'bottom:auto !important',
      'z-index:20 !important',
      'transform:none !important',
      'margin:0 !important',
      'pointer-events:none !important',
      'visibility:visible !important'
    ].join(';');
  }

  function applyFix() {
    const root = document.querySelector('#root');
    if (!root || applying) return;

    applying = true;
    if (observer) observer.disconnect();
    try {
      if (window.innerWidth > MOBILE_MAX) {
        cleanupDesktop();
        return;
      }

      positionFreeTag(root);

      leafByText(root, (t) => COLOR_LABELS.includes(t.toUpperCase())).forEach((el) => {
        remember(el);
        el.style.setProperty('font-size', 'clamp(24px, 7vw, 30px)', 'important');
        el.style.setProperty('line-height', '1.08', 'important');
        el.style.setProperty('margin-top', '0', 'important');
        el.style.setProperty('margin-bottom', '0', 'important');
      });
    } finally {
      if (observer) observer.observe(root, { childList: true, subtree: true });
      applying = false;
    }
  }

  function repeat() {
    [0, 100, 250, 500, 900, 1500, 2500, 4000].forEach((d) =>
      setTimeout(() => requestAnimationFrame(applyFix), d)
    );
  }

  function init() {
    repeat();
    const root = document.querySelector('#root');
    if (root && !observer) {
      observer = new MutationObserver(() => {
        if (!applying) requestAnimationFrame(applyFix);
      });
      observer.observe(root, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  window.addEventListener('load', repeat, { once: true });
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(repeat, 100);
  });
})();
